// nearest whole number of plants and varieties to display for marketing pages
export const PLANT_COUNT = 120;
export const VARIETY_COUNT = 1300;
